import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faArrowUpRightFromSquare, faBriefcase, faChevronLeft, faChevronRight, faMoneyCheckDollar, faLocationDot, faCalendar, faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import { faCircleCheck, faCopy, faFileLines } from '@fortawesome/free-regular-svg-icons';
import { Accordion, Modal } from 'react-bootstrap';
import { apiService } from '../../services/apiService';   
import { toast } from 'react-toastify';
import { ResizableBox } from 'react-resizable';   
import { Rating } from '@mui/material';
// import  from 'react-bootstrap/Modal';  
function ViewJobDetails() {
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const { slug } = useParams();
    const [loading, setLoading] = useState(false);
    const [previewData, setPreviewData] = useState([]);
    const [submitloader, setSubmitloader] = useState(false);
    const handleClose = () => {
        setShow(false);
    };
    const { search } = useLocation();
    const sourceName = search.startsWith('?') ? search.substring(1) : '';
    const handleBackClick = () => {
        if (sourceName === 'job-list') {
            navigate('/job-board/job-list');
        } else if (sourceName === 'my-jobs') {
            navigate('/job-board/my-job');
        } else {
            navigate(-1);
        }
    };

    const fetchPreviewData = useCallback(async () => {
        setLoading(true)
        try {
        const response = await apiService.getRequest(`jobseeker/jobs/${slug}`);
        if(response && response.success === true){
            // setPreviewData(Array.isArray(response.data) ? response.data : [response.data]);
            setPreviewData(response.data);
        }else{
            if(response && response.authenticate === false){
                await apiService.postRequest('/auth/logout');
                localStorage.clear();
                sessionStorage.clear();
                window.location.href = '/login';
            }
        }
        } catch (error) {
        console.error('Error fetching group data:', error);
        }finally{
        setLoading(false)
        }
    }, [slug]);

    useEffect(() => {
        fetchPreviewData();
    }, [fetchPreviewData]);

    const sanitizeAndDisplayHTML = (html) => {
        const sanitizedHTML = html
        return sanitizedHTML;
    };
    const handleApply = async (applyid) => {
        setSubmitloader(true);
        try {
            const params = ({
                job_id : applyid,
            })
            const response = await apiService.postRequest('/jobseeker/apply',params);
            if(response && response.success === true){
                toast(response.message || 'Job applied successfully!');
                setShow(true);
                fetchPreviewData();
            }else{
                toast(response.message || 'Failed, try again!');
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (err) {
            console.log("Failed", err);
        }finally{
            setSubmitloader(false);
        }
    };
    const handleRemoveApply = async (applyId) => {
        try {
            const response = await apiService.deleteRequest(`/jobseeker/remove-application/${applyId}`);
            if(response && response.success === true){
                fetchPreviewData();
                toast(response.message || 'Job withdrawn successfully!');
            }else{
                toast(response.message || 'Failed, try again!');
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (err) {
            console.log("Failed", err);
        }
    };
    const handleSave = async (saveid) => {
        try {
            const params = ({
                job_id : saveid
            })
            const response = await apiService.postRequest('/jobseeker/save',params);
            if(response && response.success === true){
                fetchPreviewData();
                toast(response.message || 'Job saved successfully!');    
            }else{
                toast(response.message || 'Failed, try again!');
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (err) {
            toast.error("Failed to save job");
        }
    };
    const handleRemoveSave = async (saveid) => {
        try {
            const response = await apiService.deleteRequest(`/jobseeker/remove-saved/${saveid}`);
            if(response && response.success === true){
                fetchPreviewData();
                toast(response.message || 'Job Unsaved successfully!');
            }else{
                toast(response.message || 'Failed, try again!');
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (err) {
            toast.error("Failed to Unsave job");
        }
    };
    const [articles, setArticles] = useState([]);
    const [paginatedata, setPaginateData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    
    const fetchArticles = useCallback(async (params = {}) => {
        setLoading(true);
        try {
            const defaultParams = {...params };
            const queryString = new URLSearchParams(defaultParams).toString();   
            const response = await apiService.getRequest(`/knowledge-list-articles?search=Correct My Profile${queryString}`);   
            if (response && response.success === true) {
                setArticles(response.data);
                setPaginateData(response.meta);
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error fetching tab data:', error);
        } finally {
            setLoading(false);
        }
    }, []);
    
    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        fetchArticles({ page: newPage });  
    };
    useEffect(() => {
        fetchArticles();
    }, [fetchArticles]);
  return (
    <>{previewData && previewData.status === "inactive" ? 
        <div className='container-fluid px-0'>
            <div className='content_container'>
                <Grid size={{xs:12}} container className="main_jobseeker" justifyContent="center" alignItems="center" style={{minHeight:"82vh"}}>
                    <Grid size={{md:6,sm:8,xs:10}} container className="retirewarning" flexDirection="column" alignItems="center" justifyContent="center">
                        <img src={require("../../assets/retire_warning.svg").default} alt=''/>
                        <h4>This Job is In-Active, and is no longer viewable</h4>
                        <span>It has been removed as part of regular content updates to ensure accuracy and relevance.</span>
                        <button className='registersendbtn2 my-2 px-4' onClick={()=>navigate("/job-board/job-list")} style={{width:"max-content"}}>Back to Job List</button>
                    </Grid>
                </Grid>
            </div>
        </div> :
        <div className='container-fluid px-0'>
            <div className="resizable-container d-flex">
                <div className="d-md-block d-none"> 
                    <ResizableBox 
                        className="knowledge-category"
                        width={400}    
                        height={Infinity}  
                        minConstraints={[400, Infinity]}
                        maxConstraints={[window.innerWidth - 800, Infinity]}
                        axis="x"
                        resizeHandles={['e']}
                        style={{overflowY:"auto"}}
                    >
                        <div className="knowledge-category-content">
                            <div className='catalogformside_main dragging_cats'>
                                {/* <div className='d-flex w-100 justify-content-end'>    
                                    <button className='d-md-none closecat_btn' onClick={onClose}><FontAwesomeIcon icon={faXmark} /></button>
                                </div> */}
                                <div className='d-flex flex-column'>   
                                    {loading ?
                                        <div className='d-flex justify-content-center w-100'>
                                            <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                                        </div> :
                                        <Accordion className='mt-3'>
                                            <Accordion.Item className='mb-3' eventKey="0">    
                                                <Accordion.Header className='setting_plusminus'><img src={require('../../assets/sidebaricons/star5.svg').default} alt=''/>Feedback</Accordion.Header>
                                                <Accordion.Body> 
                                                    <div className='d-flex flex-column'>
                                                        <div className='d-flex flex-column select_feedback'>
                                                            <small>How would you rate your overall experience with...</small>
                                                            <select>
                                                                <option value="1">Excellent</option>
                                                                <option value="1">Good</option>
                                                                <option value="1">Okay</option>      
                                                                <option value="1">Bad</option>   
                                                            </select>
                                                        </div>
                                                        <div className='d-flex flex-column select_feedback mt-3'>  
                                                            <small>How would you rate your overall experience with...</small>
                                                            <Rating className='rating_spanhiders justify-content-evenly' />  
                                                        </div>
                                                        <div className='d-flex flex-column select_feedback mt-3'>   
                                                            <small>Additional Comments</small>
                                                            <textarea placeholder='Write your comments'/>     
                                                        </div>
                                                        {/* <span className='d-flex align-items-center justify-content-center'>

                                                            <span className='setspanslinkcatlog_sider justify-content-center'>No data </span>
                                                        </span> */}
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                            <Accordion.Item className='mb-3' eventKey="1">
                                                <Accordion.Header className='setting_plusminus'><img src={require('../../assets/sidebaricons/flag.svg').default} alt=''/>Report</Accordion.Header>
                                                <Accordion.Body> 
                                                    <div className='d-flex flex-column'>  
                                                        <div className='d-flex flex-column select_feedback'>
                                                            <small>How would you rate your overall experience with...</small>
                                                            <select>
                                                                <option value="1">Spam or Scam</option>
                                                                <option value="1">Value 2</option>
                                                                <option value="1">Value 3</option>
                                                            </select>
                                                        </div>
                                                        <div className='d-flex flex-column select_feedback mt-3'>
                                                            <small>Additional Comments</small>
                                                            <textarea placeholder='Write your comments'/>    
                                                        </div>
                                                        <div className='d-flex flex-column select_feedback mt-3'>
                                                            <small>Please attach evidence the issue <b>(Optional)</b></small>
                                                            <label
                                                                htmlFor="fileInput"
                                                                // onDrop={handleDrop}
                                                                // onDragOver={handleDragOver}  
                                                                style={{
                                                                    display: 'block',
                                                                    border: '2px dashed #888',
                                                                    borderRadius: 3,   
                                                                    padding: 20,
                                                                    textAlign: 'center',
                                                                    cursor: 'pointer',
                                                                    backgroundColor: '#FFF6EA',
                                                                }}
                                                            >
                                                                <FontAwesomeIcon className='file_uploadericon' icon={faFileLines} />
                                                                <p className='mb-0'>click to select or drop file here</p>
                                                                <input
                                                                    id="fileInput"
                                                                    type="file"
                                                                    accept=".csv, .xls, .xlsx"
                                                                    // onChange={handleInputChange}   
                                                                    style={{ display: 'none' }}
                                                                />
                                                            </label>
                                                        </div>
                                                        {/* <span className='d-flex align-items-center justify-content-center'>   

                                                            <span className='setspanslinkcatlog_sider justify-content-center'>No data </span>
                                                        </span> */}
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                            <Accordion.Item className='mb-3' eventKey="2">
                                                <Accordion.Header className='setting_plusminus'><img src={require('../../assets/sidebaricons/icon3.svg').default} alt=''/>Related Article</Accordion.Header>
                                                <Accordion.Body> 
                                                    <div className='d-flex flex-column'>
                                                        {articles && articles.length > 0 ? (
                                                            articles && articles.map((article,index) => ( 
                                                            <a href={`/knowledge-article/${article.format_id}`} key={index} target="_blank" rel="noopener noreferrer" className='d-flex cursor_linkarticle align-items-center justify-content-between'>
                                                                <span className='setspanslinkcatlog_sider'>{article.title}</span>
                                                                <FontAwesomeIcon className='new_catalogchevron' icon={faChevronRight} />
                                                            </a>
                                                            ))
                                                        ) : ( 
                                                            <div className="w-100 d-flex justify-content-center mt-4">
                                                                <p>No data to display</p>
                                                            </div>
                                                        )}
                                                        {currentPage !== paginatedata.last_page && 
                                                        <Grid size={{xs:12}} container justifyContent="center" className="mt-4 w-100 pagination_btn_siders">
                                                            <button className='arrowpaginate' 
                                                                onClick={() => handlePageChange(currentPage - 1)} 
                                                                disabled={currentPage === 1}>
                                                                <FontAwesomeIcon icon={faChevronLeft} />
                                                            </button>
                                                            <button className='arrowpaginate'
                                                                onClick={() => handlePageChange(currentPage + 1)} 
                                                                disabled={currentPage === paginatedata.last_page}>
                                                                <FontAwesomeIcon icon={faChevronRight} />
                                                            </button>
                                                        </Grid>
                                                        }
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                    }
                                </div>
                            </div>
                        </div> 
                    </ResizableBox>
                </div>
                <div className='content_container_articals_drag' style={{ flexGrow: 1 }}>
                    <Grid size={{sm:12}} container className="main_jobseeker">
                        <Grid size={{md:12,xs:12}} container justifyContent="space-between" className="jobseekerhead">
                            <Grid container flexDirection="column">
                                <h3>Job Board</h3>
                                <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> <b onClick={handleBackClick}>Job Board</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> {slug}</span>
                            </Grid>
                            <button onClick={handleBackClick} className='registersendbtn1 m-3'>
                                <FontAwesomeIcon icon={faChevronLeft} /> Back
                            </button>
                        </Grid>
                        {loading ? 
                            <div className='d-flex justify-content-center w-100 mt-5 pt-5'>
                                <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                            </div> :<>
                            <Grid size={{xs:12}} container>
                                <Grid size={{xs:12}} container justifyContent="space-between" className="mt-5">
                                    <Grid size={{xs:12}} container alignItems="center" justifyContent="flex-end" className="gap-3 mb-3">
                                        {previewData && previewData.is_saved === true ?
                                        <button className='applyshow_savebtn' onClick={() => handleRemoveSave(previewData.id)}>
                                            <img src={require("../../assets/sample/save_tagwhite.svg").default} alt="save"/>
                                        </button> :
                                        <button className='applyshow_unsavebtn' onClick={() => handleSave(previewData.id)}>
                                            <img src={require("../../assets/sample/save_tagpink.svg").default} alt="save"/>
                                        </button>}
                                        {previewData && previewData.is_applied === true ?
                                            <>
                                            {previewData && previewData.apply_url && previewData.apply_url !== "" && previewData.apply_url !== null ? 
                                            <a className='registersendbtn2 mt-0 mb-0 register_flexatags' href={`${previewData.apply_url}`} target="_blank" rel="noopener noreferrer">View <FontAwesomeIcon icon={faArrowUpRightFromSquare} /></a> :
                                                <button className='disabled_btnapply my-0'>Applied</button>
                                            }
                                            </>:
                                            <>
                                            {previewData && previewData.apply_url && previewData.apply_url !== "" && previewData.apply_url !== null ? 
                                                <a className='registersendbtn2 mt-0 mb-0 register_flexatags' href={`${previewData.apply_url}`} target="_blank" rel="noopener noreferrer">Apply <FontAwesomeIcon icon={faArrowUpRightFromSquare} /></a>
                                                :
                                                <button className='registersendbtn2 mt-0 mb-0' onClick={() => handleApply(previewData.id)}>{submitloader ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : <>Apply <FontAwesomeIcon icon={faArrowUpRightFromSquare} /></>}</button>
                                            }</>
                                        }
                                    </Grid>
                                    <Grid size={{xs:12}} container alignItems="flex-start" className="titleadmin_joblist job_viewnames">
                                        {previewData && previewData.source === "LinkedIn" ? 
                                            <img src={require("../../assets/sample/linkedin.svg").default} alt='Job Icon'/>:
                                            previewData.source === "Monster" ?
                                            <img src={require("../../assets/sample/monster.svg").default} alt='Job Icon'/>:
                                            previewData.source === "Indeed" ?
                                            <img src={require("../../assets/sample/indeed.svg").default} alt='Job Icon'/>:
                                            previewData.source === "Glassdoor" ?
                                            <img src={require("../../assets/sample/glassdoor.svg").default} alt='Job Icon'/>:
                                            previewData.source === "Dice" ?
                                            <img src={require("../../assets/sample/dice.svg").default} alt='Job Icon'/>:
                                            previewData.source === "Techfetch" ?
                                            <img src={require("../../assets/sample/techfetch.svg").default} alt='Job Icon'/>:
                                            previewData.source === "TekP Intelligence" ?
                                            <img src={require("../../assets/sample/tekp.svg").default} alt='Job Icon'/>:
                                            <img src={require("../../assets/sample/others.svg").default} alt='Job Icon'/>}
                                        
                                        <div className='jobboard_listtitle'>
                                            <h5 className='tittle_jobswrap' style={{whiteSpace: "wrap"}}>{previewData.title}</h5>
                                            <h6 className='mb-0'>{previewData && previewData.recruiter_company && previewData.recruiter_company !== "" && previewData.recruiter_company !== "unknown" && previewData.recruiter_company }</h6>
                                        </div>
                                    </Grid>
                                </Grid>
                                <Grid size={{xs:12}} container className="mt-5 apply_forjob">
                                    <span>Did you apply for this job?</span>
                                    <div className='d-flex flex-wrap'>
                                        <label>
                                            <input
                                                type="radio"
                                                name="job_applied"
                                                value="yes"
                                                checked={previewData && previewData.is_applied === true}
                                                onChange={(e) => {
                                                    if (e.target.value === 'yes') {
                                                        handleApply(previewData.id);
                                                    }
                                                }}
                                            />
                                            Yes
                                        </label>
                                        <label style={{marginLeft: '20px'}}>
                                            <input
                                                type="radio"
                                                name="job_applied"
                                                value="no"
                                                checked={previewData && previewData.is_applied !== true}
                                                onChange={(e) => {
                                                    if (e.target.value === 'no') {
                                                        handleRemoveApply(previewData.id);
                                                    }
                                                }}
                                            />
                                            No
                                        </label>
                                    </div>
                                </Grid>
                                <Grid size={{xs:12}} container className="viewjob_totboders mt-5">
                                    <Grid size={{xs:12}} container className="spans_icons_viewjobs">
                                        {previewData && previewData.experience_range && previewData.experience_range !== "" && previewData.experience_range !== "unknown" && previewData.experience_range !== "Unknown" &&
                                            <span><FontAwesomeIcon className='job_icons' icon={faBriefcase} /> {previewData.experience_range}</span>
                                        }
                                        {previewData && previewData.salary && previewData.salary !== "" && previewData.salary !== "unknown" && previewData.salary !== "Unknown" &&
                                            <span><FontAwesomeIcon className='job_icons' icon={faMoneyCheckDollar} /> {previewData.salary}</span>
                                        }
                                        {previewData && previewData.location && previewData.location !== "" && previewData.location !== "unknown" && previewData.location !== "Unknown" &&
                                            <span><FontAwesomeIcon className='job_icons' icon={faLocationDot} /> {previewData.location}</span>
                                        }
                                        {previewData && previewData.published_on && previewData.published_on !== "" && previewData.published_on !== "unknown" && previewData.published_on !== "Unknown" &&
                                            <span><FontAwesomeIcon className='job_icons' icon={faCalendar} /> {previewData.published_on || "-"}</span>
                                        }
                                        {previewData && previewData.recruiter_email && previewData.recruiter_email[0] !== "" && previewData.recruiter_email[0] !== "unknown" &&
                                            <span className="hover_showes">
                                                <FontAwesomeIcon icon={faEnvelope} />
                                                <span>
                                                {previewData.recruiter_email[0]}
                                                {previewData.recruiter_email.length > 1 && " ..."}
                                                <button
                                                    onClick={() => {
                                                    const copyText = previewData.recruiter_email.join(", ");
                                                    navigator.clipboard.writeText(copyText);
                                                    toast("Mail ID(s) copied to clipboard");
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={faCopy} />
                                                </button>
                                                </span>
                                            </span>
                                        }
                                        {previewData && previewData.recruiter_phone && previewData.recruiter_phone !== "" && previewData.recruiter_phone !== "unknown" &&
                                            <span className='hover_showes'><FontAwesomeIcon className='mailer_icongray' icon={faPhone} />
                                                <span>{previewData.recruiter_phone} <button onClick={() => {navigator.clipboard.writeText(`${previewData.recruiter_phone}`); toast('Phone Number copied to clipboard'); }}><FontAwesomeIcon icon={faCopy} /></button></span>
                                            </span>
                                        }
                                    </Grid>
                                    <Grid size={{xs:12}} container className="spans_bodcont_viewjobs mt-3">
                                        <span>Applicants: <b>{previewData.job_post_application_count || 0}</b></span>
                                        <span>Applicants Seen: <b>{previewData.job_post_view_count || 0}</b></span>
                                        {previewData && previewData.number_of_openings && previewData.number_of_openings !== "" && previewData.number_of_openings !== "unknown" && previewData.number_of_openings !== "Unknown" &&
                                            <span>Openings: <b>{previewData.number_of_openings}</b></span>
                                        }
                                        {previewData && previewData.site_type && previewData.site_type !== "" && previewData.site_type !== "unknown" &&
                                            <span>Site Type: <b>{previewData.site_type}</b></span>
                                        }
                                        {previewData && previewData.job_type && previewData.job_type !== "" && previewData.job_type !== "unknown" &&
                                            <span>Job Type: <b>{previewData.job_type}</b></span>
                                        }
                                        {previewData && previewData.source && previewData.source !== "" && previewData.source !== "unknown" && <span>Source: <b>{previewData.source}</b></span>}
                                        {previewData && previewData.citizenship_status && previewData.citizenship_status !== "" && previewData.citizenship_status !== "unknown" &&
                                            <span>Citizenship: <b>{previewData.citizenship_status}</b></span>
                                        }
                                    </Grid>
                                    <Grid size={{xs:12}} container alignItems="flex-end" className="spans_tagsjob gap-3">
                                        {previewData && previewData.key_skills && previewData.key_skills.map((skills,indexs) =>(
                                            <span key={indexs}>{skills}</span>
                                        ))}
                                    </Grid>
                                </Grid>
                                <Grid size={{xs:12}} container className="">
                                    <Grid size={{ xs:12 }} container justifyContent="center" className="my-4">
                                        <Grid size={{xs:12}} container className="main_cardjob mt-3">
                                            <h4 className='job_disheader mb-4'>Job description</h4>
                                            {previewData && previewData.description_html && previewData.description_html !== "" && previewData.description_html !== null ?
                                                <div className='w-100 mb-3 caliberifontsset' dangerouslySetInnerHTML={{ __html: sanitizeAndDisplayHTML(previewData.description_html) }} />
                                                :
                                                <div className='w-100 mb-3 caliberifontsset' dangerouslySetInnerHTML={{ __html: sanitizeAndDisplayHTML(previewData.description) }} />
                                            }
                                            <Grid size={{xs:12}} container alignItems="center" justifyContent="flex-end" className="spans_tagsjob mb-3 gap-3">
                                                {previewData && previewData.is_applied === true ?
                                                    <>
                                                    {previewData && previewData.apply_url && previewData.apply_url !== "" && previewData.apply_url !== null ? 
                                                        <a className='registersendbtn2 mt-0 mb-0 register_flexatags' href={`${previewData.apply_url}`} target="_blank" rel="noopener noreferrer">View <FontAwesomeIcon icon={faArrowUpRightFromSquare} /></a> :
                                                        <button className='disabled_btnapply my-0'>Applied</button>
                                                    }
                                                    </>:
                                                    <>
                                                    {previewData && previewData.apply_url && previewData.apply_url !== "" && previewData.apply_url !== null ? 
                                                        <a className='registersendbtn2 mt-3 mb-0 register_flexatags' href={`${previewData.apply_url}`} target="_blank" rel="noopener noreferrer">Apply <FontAwesomeIcon icon={faArrowUpRightFromSquare} /></a>
                                                        :
                                                        <button className='registersendbtn2 mt-3 mb-0' onClick={() => handleApply(previewData.id)}>{submitloader ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : <>Apply <FontAwesomeIcon icon={faArrowUpRightFromSquare} /></>}</button>
                                                    }</>
                                                }
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </>}
                    </Grid>
                    <Modal
                        show={show} 
                        onHide={handleClose}
                        size="md"
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                    >
                        <Modal.Header closeButton style={{border:"none"}}>
                            
                        </Modal.Header>
                        <Modal.Body>
                            <div className='d-flex w-100 text-center flex-column align-items-center apply_successpop'>
                                <FontAwesomeIcon className='main_tickiconpopup' icon={faCircleCheck} />
                                <h5 className='mt-4'>Successfully Added to your applied jobs</h5>
                                <small>You can keep track of your application in your applied jobs</small>
                                <button className='registersendbtn2' onClick={handleBackClick}>Show Jobs</button>
                            </div>
                        </Modal.Body>
                    </Modal>
                </div>
            </div>
        </div>}
    </>
  )
}

export default ViewJobDetails
